const getTagFontColor = (color?: string) => {
  if (color?.toUpperCase() === '#E7E4F9') return '#524988';
  if (color?.toUpperCase() === '#DCF2EA') return '#317159';
  if (color?.toUpperCase() === '#FFEFD2') return '#66460D';
  if (color?.toUpperCase() === '#D3F5F7') return '#0F5156';
  if (color?.toUpperCase() === '#F8E3DA') return '#85462B';
  if (color?.toUpperCase() === '#FBDDF3') return '#8E3374';
  if (color?.toUpperCase() === '#F9DADA') return '#7D2828';
  if (color?.toUpperCase() === '#E6EDFF') return '#1F3D99';
  return '#474d66';
};

export { getTagFontColor };
